import React, { useEffect, useState, Suspense } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDestinationColorIcon } from '../../../../../../helpers/cms/subscriber.js';
import { useActiveDestination } from '../../../../../../helpers/customHooks';
import CenterSpinner from '../../../../../general/Loadings/CenterSpinner';
import { setFlexibleModal, setRuleHaveEditting } from '../../../../../../actions/common';
import { API_CLIENT_ACCOUNT_RULE, API_CLIENT_GET_SEGMENT_OPTION } from '../../../../../../constants/apiRest.js';
import { toastError } from '../../../../../../utils/index.js';
import { callTokenApi } from '../../../../../../apiCaller.js';
import { TYPE_SHOW_UNSAVE_CHANGE } from '../../../../../../constants/index.js';
import { fetchDimensionsRequest, fetchScopesRequest, fetchIntentProperties, getSalesConversionObject, getSalesConversionName } from '../../../../../../actions/subscriber.js';
import { SEGMENT_VARIABLE_OPTION } from '../../../../../../constants/segment.js';

const Step1 = React.lazy(() => import('./steps/Step1.js'));
const Step2 = React.lazy(() => import('./steps/Step2.js'));
const Step3 = React.lazy(() => import('./steps/Step3.js'));
const Step4 = React.lazy(() => import('./steps/Step4.js'));

export const RuleContext = React.createContext({});

const DataActionRuleServerSide = ({ id }) => {
     const dispatch = useDispatch();
     const activeDestination = useActiveDestination();
     const listenerIconSrc = getDestinationColorIcon(activeDestination);
     const customDimensions = useSelector((state) => state.subscriber.customReport.dimensions);
     const scopes = useSelector((state) => state.subscriber.customReport.scopes);
     const [fetchRuleLoading, setFetchRuleLoading] = useState(false);
     const activeAccount = useSelector((state) => state.subscriber.activeAccount);
     const { id: accountId } = activeAccount;
     const [fetchDimensionLoading, setFetchDimensionLoading] = useState(false);
     const [isLoadingOption, setIsLoadingOption] = useState(false);
     const [reportOption, setReportOption] = useState({})

     const fetchListSegmentOption = () => {
          const data = { accountId, variables: [SEGMENT_VARIABLE_OPTION.METRIC, SEGMENT_VARIABLE_OPTION.DATA_ACTION_OTHER_FIELD] };

          setIsLoadingOption(true);
          callTokenApi(API_CLIENT_GET_SEGMENT_OPTION, 'POST', data)
               .then((response) => {
                    if (response.status === 200) {
                         setReportOption({ ...reportOption, ...response.data.data });
                    }
               })
               .catch((error) => {
                    console.error('Error fetching list segment option:: ', error);
               })
               .finally(() => {
                    setIsLoadingOption(false);
               });
     };

     useEffect(() => {
          if (customDimensions.length === 0) {
               dispatch(fetchDimensionsRequest(accountId, setFetchDimensionLoading));
          }

          if (scopes.length === 0) {
               dispatch(fetchScopesRequest(accountId));
          }

          fetchListSegmentOption();
          dispatch(fetchIntentProperties(accountId))
     }, [accountId]); // eslint-disable-line react-hooks/exhaustive-deps

     useEffect(() => {
          dispatch(getSalesConversionObject(accountId));
          dispatch(getSalesConversionName(accountId));
     }, [accountId]) //eslint-disable-line

     const [stepsData, setStepsData] = useState({
          name: '',
          description: '',
          conditions: {
               triggerIds: []
          },
          customVariables: {},
          data: {},
          group: 'dataAction',
          type: 'simple',
          value: '',
          dataActionType: 'serverSide'
     });
     const [activeStep, setActiveStep] = useState(1);

     const fetchRule = () => {
          if (id && stepsData && stepsData.id !== id) {
               setFetchRuleLoading(true);
               callTokenApi(`${API_CLIENT_ACCOUNT_RULE}/${id}`, 'GET')
                    .then((response) => {
                         if (response.status === 200) {
                              const { rule } = response.data;
                              if (rule.accountId !== activeAccount.id) {
                                   window.location.href = '/';
                              }
                              const { conditions, data, records } = rule;
                              const { triggerIds, primaryObject } = conditions || {};
                              const { payload, webhookUrl, dataActionTemplate, token, contactsKey, apiKey, listId, salesforce } = data || {};

                              setStepsData({
                                   ...rule,
                                   triggerIds,
                                   primaryObject,
                                   payload,
                                   webhookUrl,
                                   dataActionTemplate,
                                   token,
                                   contactsKey,
                                   apiKey,
                                   listId,
                                   salesforce,
                                   records
                              });
                         } else {
                              toastError(response);
                         }
                    })
                    .finally(() => {
                         setFetchRuleLoading(false);
                    });
          }
     };

     useEffect(fetchRule, [id]); // eslint-disable-line react-hooks/exhaustive-deps

     const handleHasChange = () => {
          dispatch(setRuleHaveEditting({ show: true, type: TYPE_SHOW_UNSAVE_CHANGE.EDIT_SIMPLE }));
     };

     const handleNextSuccess = () => {
          dispatch(
               setFlexibleModal({
                    show: false,
                    component: '',
               })
          );
          dispatch(setRuleHaveEditting({ show: '', type: '' }));
     };

     const contextValue = {
          activeStep,
          setActiveStep,
          stepsData,
          setStepsData,
          handleNextSuccess,
          handleHasChange,
          reportOption
     };
     return (
          <div className='rule-detail'>
               {fetchRuleLoading || fetchDimensionLoading || isLoadingOption ? (
                    <CenterSpinner />
               ) : (
                    <div className="cvr-create-new cvr-create-new-dataAction">
                         <h1 className="d-flex">
                              <img className="listener-icon-headline" src={listenerIconSrc} alt={activeDestination.name + ' icon'} />
                              {id ? 'Edit' : 'Create'} a Data Action
                         </h1>
                         <p>Complete these steps to configure your data action.</p>
                         <RuleContext.Provider value={contextValue}>
                              <Suspense fallback={<CenterSpinner />}>
                                   <Step1 />
                                   <Step2 />
                                   <Step3 />
                                   <Step4 />
                              </Suspense>
                         </RuleContext.Provider>
                    </div>
               )}
          </div>
     )
};

export default DataActionRuleServerSide;
